import React from 'react'

function NotFound() {
  return <div className="flex items-center justify-center min-h-screen font-bold text-3xl">
    404🪴
  </div>
}

export default NotFound
